import { consoleDev } from 'shared/utils/utils';
import { WebApp, getMaxInitDataRawString } from './maxBridge';
import { dumpMaxWebAppToConsole } from './maxWebAppDebug';

export const initializeMaxSDK = async () => {
  try {
    const webApp = window.WebApp;

    if (webApp && getMaxInitDataRawString()) {
      // 1. Сообщаем MAX, что мини-приложение готово к работе
      webApp.ready();
      dumpMaxWebAppToConsole();
      console.log('MAX SDK initialized successfully');
      return;
    }

    // Если SDK отсутствует или нет данных (например, в браузере), создаем/дополняем мок
    consoleDev('Initializing Mock MAX SDK environment...');

    const mockData = {
      initData: 'query_id=mock_query_id_123456',
      initDataUnsafe: {
        user: {
          id: 123456,
          first_name: 'Max',
          last_name: 'Developer',
          username: 'max_dev',
          language_code: 'ru',
        },
        auth_date: Math.floor(Date.now() / 1000),
        hash: 'mock_hash',
      },
      version: '25.9.16',
      platform: 'web',
    };

    if (webApp) {
      // Если объект уже создан библиотекой, но пустой, дополняем его
      Object.assign(webApp, mockData);
      webApp.ready = () => consoleDev('Mock MAX SDK: ready() called');
    } else {
      // Если объекта нет совсем, создаем с нуля
      const mockWebApp: Partial<WebApp> = {
        ...mockData,
        ready: () => consoleDev('Mock MAX SDK: ready() called'),
        close: () => consoleDev('Mock MAX SDK: close() called'),
        onEvent: eventName =>
          consoleDev(`Mock MAX SDK: onEvent('${eventName}') subscribed`),
        offEvent: eventName =>
          consoleDev(`Mock MAX SDK: offEvent('${eventName}') unsubscribed`),
        sendData: data =>
          consoleDev('Mock MAX SDK: sendData() called with:', data),
        BackButton: {
          isVisible: false,
          onClick: () => consoleDev('Mock MAX SDK: BackButton onClick'),
          offClick: () => consoleDev('Mock MAX SDK: BackButton offClick'),
          show: () => consoleDev('Mock MAX SDK: BackButton show()'),
          hide: () => consoleDev('Mock MAX SDK: BackButton hide()'),
        },
        HapticFeedback: {
          impactOccurred: style =>
            consoleDev(`Mock MAX SDK: Haptic impactOccurred(${style})`),
          notificationOccurred: type =>
            consoleDev(`Mock MAX SDK: Haptic notificationOccurred(${type})`),
          selectionChanged: () =>
            consoleDev('Mock MAX SDK: Haptic selectionChanged()'),
        },
        openLink: url => consoleDev(`Mock MAX SDK: openLink(${url})`),
        openMaxLink: url => consoleDev(`Mock MAX SDK: openMaxLink(${url})`),
        shareContent: params =>
          consoleDev('Mock MAX SDK: shareContent()', params),
      };
      // @ts-ignore
      window.WebApp = mockWebApp as WebApp;
    }

    window.WebApp.ready();
    dumpMaxWebAppToConsole();
    console.log('Mock MAX SDK environment initialized');
  } catch (e) {
    console.error('MAX SDK initialization failed:', e);
  }
};
